import { PremiumFolderType } from '../types/gallection';
import { formatDollars } from './formatting';
export function normalizePremiumFolderData(premiumFolderData) {
    var _premiumFolderData_eligibleDiscount;
    const isPremiumContent = !!premiumFolderData;
    const dollarPrice = premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.dollarPrice;
    const formattedDollarPrice = formatDollars(dollarPrice);
    // Calculate price after discount
    let dollarPriceAfterDiscount = dollarPrice;
    const amount = premiumFolderData === null || premiumFolderData === void 0 ? void 0 : (_premiumFolderData_eligibleDiscount = premiumFolderData.eligibleDiscount) === null || _premiumFolderData_eligibleDiscount === void 0 ? void 0 : _premiumFolderData_eligibleDiscount.amount;
    if (amount) {
        if (amount.usd && dollarPrice) {
            dollarPriceAfterDiscount = dollarPrice - amount.usd;
        } else if (amount.percent && dollarPrice) {
            dollarPriceAfterDiscount = dollarPrice - dollarPrice * amount.percent / 100;
        }
    }
    const formattedDollarPriceAfterDiscount = formatDollars(dollarPriceAfterDiscount);
    return {
        isPremium: isPremiumContent,
        isPremiumLocked: isPremiumContent && !(premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.hasAccess),
        isPaidFolder: isPremiumContent && (premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type) === PremiumFolderType.Paid,
        isWatchToAccess: isPremiumContent && (premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type) === PremiumFolderType.Watchers,
        pointPrice: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.pointsPrice,
        formattedDollarPrice,
        formattedDollarPriceAfterDiscount,
        folderId: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.galleryId,
        folderUrl: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.galleryUrl,
        numSubscribers: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.numSubscribers,
        subproductId: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.subproductId,
        eligibleDiscount: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.eligibleDiscount,
        notEligibleDiscounts: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.notEligibleDiscounts
    };
}

//# sourceMappingURL=normalizePremiumFolderData.js.map